<template>
  <div>
    <div v-if="activeUserTeam.id">
      <div v-if="activeUserTeam.checklistConfirmedAt">
        <b-button
          v-if="status === true"
          size="sm"
          variant="success"
          pill
          :disabled="isTeamWorkingOnOrder"
          @click="toggleStatus"
        >
          {{ $t('team.status-switcher.active') }}
        </b-button>
        <b-button
          v-if="status === false"
          size="sm"
          variant="danger"
          pill
          :disabled="isTeamWorkingOnOrder"
          @click="toggleStatus"
        >
          {{ $t('team.status-switcher.inactive') }}
        </b-button>
      </div>
      <div v-else>
        <b-button
          variant="flat-warning"
          :to="{ name: 'team-checklist' }"
        >
          <feather-icon
            icon="CheckSquareIcon"
            size="16"
          />
          <span class="d-none d-md-inline-block ml-50">{{ $t('team.status-switcher.check-checklist') }}</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'
import { TEAM_ACTIVE_ORDER_STATUSES } from '@/constants/team'
import { parseRequestError } from '@/helpers/helpers'

export default {
  components: { BButton },
  data() {
    return {
      status: null,
      disabled: false,
    }
  },
  computed: {
    activeUserTeam() {
      return this.$store.getters['auth/getUserTeam']
    },
    activeUserTeamStatus() {
      return this.$store.getters['auth/getUserTeam'].status
    },
    isTeamWorkingOnOrder() {
      if (!this.$store.getters['auth/getUserTeam'].currentOrder) {
        return false
      }

      return TEAM_ACTIVE_ORDER_STATUSES.includes(this.$store.getters['auth/getUserTeam'].currentOrder.status)
    },
  },
  watch: {
    activeUserTeamStatus(status) {
      this.status = status
    },
  },
  mounted() {
    setTimeout(() => {
      this.status = this.activeUserTeamStatus
    }, 500)
  },
  methods: {
    toggleStatus() {
      if (this.disabled || this.isTeamWorkingOnOrder) {
        return
      }
      this.status = !this.status
      this.disabled = true
      this.$nextTick(() => {
        this.$store.dispatch('auth/updateUserTeamStatus', { status: this.status, teamId: this.activeUserTeam.id })
          .then(() => {
            window.toast.notify.success(this.$t('team.status-switcher.team-status-changed'))
          })
          .catch(error => {
            this.status = this.activeUserTeamStatus
            parseRequestError(error)
          })
          .finally(() => {
            this.disabled = false
          })
      })
    },
  },
}
</script>
